<span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
  <p
    #tooltip="matTooltip"
    [matTooltip]="name"
    [class.big]="size === 'big'"
    [class.medium]="size === 'medium'"
    matTooltipClass="tooltip"
    matTooltipPosition="before"
    [style.background-color]="backgroundColor"
    [style.color]="color"
    class="avatar"
    >
    {{ acronym }}
  </p>
  @if (showName) {
    <p class="name p-1">{{ name }}</p>
  }
</span>
